// extracted by mini-css-extract-plugin
export var bottom = "style-module--bottom--a9595";
export var buttonContainer = "style-module--buttonContainer--31e1e";
export var copyright = "style-module--copyright--575bd";
export var footer = "style-module--footer--937a4";
export var history = "style-module--history--88f52";
export var icon = "style-module--icon--d5d68";
export var icons = "style-module--icons--4e5c1";
export var items = "style-module--items--5362f";
export var label = "style-module--label--2f842";
export var links = "style-module--links--66742";
export var logo = "style-module--logo--763e5";
export var navigationMenu = "style-module--navigationMenu--e4e3f";
export var note = "style-module--note--fef51";
export var notice = "style-module--notice--b48e7";
export var othersMenu = "style-module--othersMenu--829e3";
export var save = "style-module--save--76a53";
export var snsMenu = "style-module--snsMenu--1619a";
export var top = "style-module--top--a634b";